import React from "react";
import { Trans } from "@lingui/macro";
import _ from "lodash";
import subsidiariesMarker from "../images/markers/red.png";
import mainOfficesMarker from "../images/markers/orange.png";
import representativeMarker from "../images/markers/green.png";
import branchesMarker from "../images/markers/yellow.png";
import offices from "../cms/offices/offices";

export const availablesLanguages = ["en", "es", "it", "fr"];

export const officeKinds = (locale = "en") => [
  {
    value: "headquarters",
    kind: <Trans>Headquarters</Trans>,
    offices: _.groupBy(offices[locale], "attributes.kind").Headquarters,
    icon: mainOfficesMarker,
  },
  {
    value: "subsidiaries",
    kind: <Trans>Subsidiaries</Trans>,
    offices: _.groupBy(offices[locale], "attributes.kind").Subsidiaries,
    icon: subsidiariesMarker,
  },
  {
    value: "branches",
    kind: <Trans>Branches</Trans>,
    offices: _.groupBy(offices[locale], "attributes.kind").Branches,
    icon: branchesMarker,
  },
  {
    value: "representative",
    kind: <Trans>Representative Offices</Trans>,
    offices: _.groupBy(offices[locale], "attributes.kind").Representative_Offices,
    icon: representativeMarker,
  },
];

export const optionsOffices = (locale = "en") => {
  const options = [
    _.groupBy(offices[locale], "attributes.kind").Branches,
    {
      ..._.groupBy(offices[locale], "attributes.kind").Headquarters?.find(
        ({ attributes: { city } }) => city === "Madrid",
      ),
      extraLabel: "Headquarters & Rep.Offices",
    },
    {
      ..._.groupBy(offices[locale], "attributes.kind").Subsidiaries?.find(
        ({ attributes: { city } }) => city === "Hong Kong",
      ),
      extraLabel: "Limited",
    },
  ].flat();
  const branches = options?.map(({ attributes: { city, complaint_emails }, extraLabel = "Branch" }) => ({
    value: city,
    label: `${city} ${extraLabel}`,
    complaint_emails,
  }));
  return branches;
};

// export const offices = (isBranch = false) => ({
//   madrid: {
//     label: "Madrid",
//     value: "madrid",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Calle de los padres Dominicos, 7</Typography>
//         <Typography>28050 Madrid</Typography>
//         <Typography>Spain</Typography>
//       </>
//     ),
//     position: { lat: 40.416775, lng: -3.70379 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//     ],
//   },
//   hongkong: {
//     label: "Hong Kong",
//     value: "hongkong",
//     details: (
//       <>
//         <Typography>Allfunds Hong Kong Limited</Typography>
//         <Typography>The Hong Kong Club Building · Room 1609-10</Typography>
//         <Typography>3A Chater Road · Central · Hong Kong</Typography>
//       </>
//     ),
//     position: { lat: 22.28169, lng: 114.161 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "alice.lyu@allfunds.com",
//     ],
//   },
//   valencia: {
//     label: "Valencia",
//     value: "valencia",
//     details: (
//       <>
//         <Typography>Allfunds Digital, S.L.U.</Typography>
//         <Typography>Calle Travesía, 15B</Typography>
//         <Typography>Base 2, 46024</Typography>
//         <Typography>Valencia</Typography>
//       </>
//     ),
//     position: { lat: 39.45648954281333, lng: -0.3295343725924049 },
//   },
//   london: {
//     label: "London",
//     value: "london",
//     details: (
//       <>
//         {isBranch ? (
//           <>
//             <Typography>Allfunds London Branch</Typography>
//             <Typography>Allfunds Bank, S.A.U.</Typography>
//           </>
//         ) : (
//           <Typography>Allfunds Group plc</Typography>
//         )}
//         <Typography>2 Fitzroy Place, 8 Mortimer Street</Typography>
//         <Typography>W1T 3JJ London</Typography>
//         <Typography>United Kingdom</Typography>
//       </>
//     ),
//     position: { lat: 51.51915864442392, lng: -0.1380452299863301 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "anthony.wells@allfunds.com",
//     ],
//   },
//   luxembourg: {
//     label: "Luxembourg",
//     value: "luxembourg",
//     details: (
//       <>
//         {isBranch && <Typography>Allfunds Luxembourg Branch</Typography>}
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Luxembourg Branch</Typography>
//         <Typography>Boulevard Royal, 30 L-2449 Luxembourg</Typography>
//         <Typography>Luxembourg</Typography>
//       </>
//     ),
//     position: { lat: 49.61002072242569, lng: 6.125795854621577 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "Clientcomplaint@allfundsinternational.com",
//       "Ybuker@allfunds.com",
//     ],
//   },
//   milan: {
//     label: "Milan",
//     value: "milan",
//     details: (
//       <>
//         {isBranch && <Typography>Allfunds Milan Branch</Typography>}
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Via Bocchetto, 6</Typography>
//         <Typography>20123 Milan</Typography>
//         <Typography>Italy</Typography>
//       </>
//     ),
//     position: { lat: 45.463864525036385, lng: 9.183902469866817 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "massimo.sattin@allfunds.com",
//     ],
//   },
//   paris: {
//     label: "Paris",
//     value: "paris",
//     details: (
//       <>
//         {isBranch && <Typography>Allfunds Paris Branch</Typography>}
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>18/20 Place de la Madeleine</Typography>
//         <Typography>75008 Paris</Typography>
//         <Typography>France</Typography>
//       </>
//     ),
//     position: { lat: 48.87044505420873, lng: 2.3254654239148307 },
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "solveig.hamon@allfunds.com",
//     ],
//   },
//   singapore: {
//     label: "Singapore",
//     value: "singapore",
//     details: (
//       <>
//         <Typography>Allfunds Singapore Branch</Typography>
//         <Typography>6 Battery Road #15-06</Typography>
//         <Typography>049909 Singapore</Typography>
//         <Typography>Singapore</Typography>
//       </>
//     ),
//     position: { lat: 1.2858071664881008, lng: 103.85190821103576 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "weemeng.phua@allfunds.com",
//     ],
//   },
//   stockholm: {
//     label: "Stockholm",
//     value: "stockholm",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Stockholm Branch Sweden filial</Typography>
//         <Typography>Östermalmstorg 1, SE 114 42 - Stockholm</Typography>
//         <Typography>Sweden</Typography>
//       </>
//     ),
//     position: { lat: 59.33655124472712, lng: 18.079206985566323 },
//     widget: true,
//     mails: [
//       "cajsa.browal@ext.allfunds.com",
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//     ],
//   },
//   warsaw: {
//     label: "Warsaw",
//     value: "warsaw",
//     details: (
//       <>
//         {isBranch && <Typography>Allfunds Warsaw Branch</Typography>}
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>
//           (Spółka Akcyjna) Poland Branch ul. Rondo Daszyńskiego 2B (Warsaw Hub)
//         </Typography>
//         <Typography>00-843 Warsaw</Typography>
//         <Typography>Poland</Typography>
//       </>
//     ),
//     position: { lat: 52.22872205279924, lng: 20.984736356540008 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "ewa.kanafa@allfunds.com",
//     ],
//   },
//   zurich: {
//     label: "Zurich",
//     value: "zurich",
//     details: (
//       <>
//         {isBranch && <Typography>Allfunds Zurich Branch</Typography>}
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Zurich Branch Bahnhofstrasse, 13</Typography>
//         <Typography>CH - 8001 Zurich</Typography>
//         <Typography>Switzerland</Typography>
//       </>
//     ),
//     position: { lat: 47.36907587342369, lng: 8.539314660368314 },
//     widget: true,
//     mails: [
//       "atencionalcliente@allfunds.com",
//       "complaintshandlingservice@allfunds.com",
//       "mirjam.pusca@allfunds.com",
//     ],
//   },
//   santiago: {
//     label: "Santiago de Chile",
//     value: "santiago",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Representative Office</Typography>
//         <Typography>Vitacura, 2969 - Office 1202</Typography>
//         <Typography>Las Condes, Santiago de Chile</Typography>
//       </>
//     ),
//     position: { lat: -33.409805306357796, lng: -70.60202061874158 },
//     widget: true,
//   },
//   dubai: {
//     label: "Dubai",
//     value: "dubai",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>DIFC Representative Office</Typography>
//         <Typography>Dubai International Financial Centre</Typography>
//         <Typography>The Gate Building, West Wing, Office 402</Typography>
//         <Typography>PO Box 506601 Dubai</Typography>
//         <Typography>United Arab Emirates</Typography>
//       </>
//     ),
//     position: { lat: 25.21500268214185, lng: 55.281223698325114 },
//     widget: true,
//   },
//   bogota: {
//     label: "Bogotá",
//     value: "bogota",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Representative Office</Typography>
//         <Typography>Av. Carrera, 9ª No. 115-06/30, Office 808</Typography>
//         <Typography>Bogotá D.C.</Typography>
//         <Typography>Colombia</Typography>
//       </>
//     ),
//     position: { lat: 4.693535710955504, lng: -74.03457511718983 },
//     widget: true,
//   },
//   saopaulo: {
//     label: "Sao Paulo",
//     value: "saopaulo",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Representative Office</Typography>
//         <Typography>Spazio Faria Lima Building</Typography>
//         <Typography>Av. Brigadeiro Faria Lima, 3355 – 10th floor</Typography>
//         <Typography>Sao Paulo</Typography>
//         <Typography>Brazil</Typography>
//       </>
//     ),
//     position: { lat: -23.585402165416458, lng: -46.682384215188165 },
//     widget: true,
//   },
//   miami: {
//     label: "Miami",
//     value: "miami",
//     details: (
//       <>
//         <Typography>Allfunds Bank, S.A.U.</Typography>
//         <Typography>Representative Office</Typography>
//         <Typography>600 Brickell Avenue, Suite 1570</Typography>
//         <Typography>Miami, FL 33131</Typography>
//       </>
//     ),
//     position: { lat: 25.767708723840936, lng: -80.1913540881753 },
//     widget: true,
//   },
//   webfg: {
//     label: "Allfunds Tech Solutions, S.A.U.",
//     value: "webfg",
//     details: (
//       <>
//         <Typography>Av. de Bruselas, 20,</Typography>
//         <Typography>28108 Alcobendas, Madrid</Typography>
//         <Typography>Spain</Typography>
//       </>
//     ),
//     position: { lat: 40.53189513942973, lng: -3.6376355014061112 },
//   },
//   instihub: {
//     label: "Allfunds Data Analytics Limited",
//     value: "instihub",
//     details: (
//       <>
//         <Typography>2 Fitzroy Place, 8 Mortimer Street</Typography>
//         <Typography>London, England W1T 3JJ</Typography>
//         <Typography>United Kingdom</Typography>
//       </>
//     ),
//     position: { lat: 51.53096774053635, lng: -0.11877012998603109 },
//   },
//   shanghai: {
//     label: "Shanghai",
//     value: "shanghai",
//     details: (
//       <>
//         <Typography>Allfunds Information & Technology Services</Typography>
//         <Typography>WOFE Office</Typography>
//         <Typography>Suite A27, 28th Floor, 100 Century Avenue</Typography>
//         <Typography>Shanghai World Financial Center</Typography>
//         <Typography>Shanghai Pilot Free Trade Zone 200120</Typography>
//       </>
//     ),
//     position: { lat: 31.234815150135027, lng: 121.50806059233578 },
//   },
//   blockchain: {
//     label: "Allfunds Blockchain",
//     value: "blockchain",
//     details: (
//       <>
//         <Typography>Calle de los Padres Dominicos, 7</Typography>
//         <Typography>28050 Madrid</Typography>
//         <Typography>Spain</Typography>
//       </>
//     ),
//   },
// })
